import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import MapboxPage from '../../Components/MapboxComponent/MapboxComponent';

import '../CommonStyles.css';

function MapboxPageComponent(props) {
  const { data } = props;
  // const options = data.optionProviderRequestList;
  const options = _.orderBy(data?.optionProviderRequestList, 'optionOrder', 'asc');

  return (
    <div className="mapboxPage">
      <MapboxPage optionData={options} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
  };
};

export default connect(mapStateToProps)(MapboxPageComponent);
